import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  createCustomerType,
  deleteCustomerType,
  fetchCustomerType,
  updateCustomerType,
} from "../../../services/customerTypeService";

export const fetchCustomerTypeAsync = createAsyncThunk(
  "customertype/fetchCustomerType",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchCustomerType();
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch CustomerType data"
      );
    }
  }
);

export const createCustomerTypeAsync = createAsyncThunk(
  "customertype/createDepartment",
  async (CstomerTypeDate, { rejectWithValue }) => {
    try {
      const response = await createCustomerType(CstomerTypeDate);
      return response;
    } catch (error) {
      console.error("Error creating role:", error);
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const deleteCustomerTypeAsync = createAsyncThunk(
  "customertype/deleteCustomerType",
  async (id, { rejectWithValue }) => {
    try {
      await deleteCustomerType(id);
      return id;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateCustomerTypeAsync = createAsyncThunk(
  "customertype/updateCustomerType",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await updateCustomerType(id, data);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to update CustomerType"
      );
    }
  }
);

const CustomerTypeSlice = createSlice({
  name: "CustomerType",
  initialState: {
    CustomerTypeData: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomerTypeAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCustomerTypeAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.CustomerTypeData = action.payload;
      })
      .addCase(fetchCustomerTypeAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createCustomerTypeAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createCustomerTypeAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.CustomerTypeData.push(action.payload);
      })
      .addCase(createCustomerTypeAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(deleteCustomerTypeAsync.fulfilled, (state, action) => {
        state.CustomerTypeData = state.CustomerTypeData.filter(
          (item) => item.id !== action.payload
        );
      })
      .addCase(deleteCustomerTypeAsync.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(updateCustomerTypeAsync.fulfilled, (state, action) => {
        const index = state.CustomerTypeData.findIndex(
          (item) => item.id === action.payload.id
        );
        if (index !== -1) {
          state.CustomerTypeData[index] = action.payload;
        }
      })
      .addCase(updateCustomerTypeAsync.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default CustomerTypeSlice.reducer;
